import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'clan-auth';
import { GlobalEventsService } from 'src/app/services/global/global-events-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private globalEventsService: GlobalEventsService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        this.globalEventsService.setIsAuthenticated(this.authenticationService.isValid());

        return next.handle(request);
    }
}
